<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col md="12">
          <b-card>
            <!-- Header Upload Button Start-->
            <div slot="header">
              <strong>Direct Dispatch</strong>
              <div class="card-header-actions" >
                <b-button size="sm" class="btn btn-sm btn-primary mr-4 btn-pill" data-toggle="tooltip" title="Upload Direct Dispatch CSV" variant='primary' @click="showUploadDirectDispatchCSV()" :disabled="isReadOnly">Upload CSV</b-button>
              </div>
            </div>
            <!-- Header Upload Button End-->

            <!-- Upload CSV Collapse Start -->
            <div v-if="directDispatchCollapse">
              <b-card>
                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                  <b-row md="12">
                    <b-col md="6">
                      <b-form-group>
                        <b-row>
                          <b-col md="3">
                            <label><b>Upload File</b></label>&nbsp;<span style="color: red;">*</span>
                          </b-col>
                          <b-col md="9">
                            <b-form-file
                            type="file"
                            v-model="directDispatcfile"
                            :state="Boolean(directDispatcfile)"
                            @change="selectcsvFiletoUpload($event)"
                            placeholder="Upload CSV File"
                            accept=".csv"
                            required
                            v-validate="'required'"
                            :class="{
                            file: true,
                            'is-invalid': errors.has('form-1.file'),
                            }"
                            ></b-form-file>
                            <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning"
                                v-show="errors.has('file')"
                                ></i>
                              </span>
                              <code
                                v-show="errors.has('form-1.file')"
                                id="addmblnbrmsg"
                                class="help text-danger"
                                >{{ errors.first("form-1.file") }}
                              </code>
                            </b-input-group>
                            <div>
                              <label for="name" ><a
                                href="img/direct_dispatch.csv"
                                download="direct_dispatch.csv"
                                target="_blank"
                                >Download Sample CSV</a
                                >
                              </label>
                            </div>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-button variant="primary" @click="uploadDispatchCSVFile()">Upload</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card>
            </div>
            <!-- Upload CSV Collapse End -->


            <div id="showerror" style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
                <b-row>
                    <b-col md="12">
                        <span>
                        <h6>
                            <b>Accepted AWB : </b>
                          
                         <strong
                            v-if="acceptedAwbNo.length"
            
                            v-for="acceptedAwbNo in acceptedAwbNo"
                            >{{ acceptedAwbNo }} &nbsp;&nbsp;
                            </strong>
                        </h6>

                        <br />

                        <h6>
                            <b>Rejected AwbNo For InvalidStatus : </b>
                            
                            <strong
                            v-if="rejectedAwbNoForInvalidStatus.length"
            
                            v-for="rejectedAwbNoForInvalidStatus in rejectedAwbNoForInvalidStatus"
                            >{{ rejectedAwbNoForInvalidStatus }} &nbsp;&nbsp;
                            </strong>
                        </h6>

                        <br />
                    
                        <h6>
                            <b>Rejected AwbNo For Invalid VehicleId : </b>
                            
                            <strong
                            v-if="rejectedAwbNoForInvalidVehicleId.length"
                            style="color:#FF6347;"
                            v-for="rejectedAwbNoForInvalidVehicleId in rejectedAwbNoForInvalidVehicleId"
                            >{{ rejectedAwbNoForInvalidVehicleId }} &nbsp;&nbsp;
                            </strong>
                            
                        </h6>

                        <br />

                        <h6>
                            <b>Rejected Due To Insert Error : </b>
                          
                            <strong
                            v-if="rejectedDueToInsertError.length"
                            style="color:#FF6347;"
                            v-for="rejectedDueToInsertError in rejectedDueToInsertError"
                            >{{ rejectedDueToInsertError }} &nbsp;&nbsp;
                            </strong>
                        </h6>
                        <br>

                        <h6>
                            <b>Duplicate Awb No : </b>
                          
                            <strong
                            v-if="duplicateAwbNoArr.length"
                            style="color:#FF6347;"
                            v-for="duplicateAwbNoArr in duplicateAwbNoArr"
                            >{{ duplicateAwbNoArr }} &nbsp;&nbsp;
                            </strong>
                        </h6>
                        <br>
                        
                        </span>
                    </b-col>
                </b-row>
            </div>
            <!-- table Listing -->
            <div>
                <b-row md="12">
                    <b-col md="12" class="text-right">
                      <p><b>Total Records :<span style="color:red;">{{ totalRows }}</span>
                     </b></p>
                    </b-col>
                    <b-col sm="12">
                        <b-table show-empty responsive   :items="items" :busy="isBusy" :fields="fields" :filter="filter"  :current-page="currentPage"  :per-page="perPage"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered"> 
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div> 

                            <template slot="actions" slot-scope="row" >
                                <a :href="row.item.upload_path" target="_blank"><i
                                    class="fa fa-download"
                                    aria-hidden="true"
                                    title="Click to download"
                                    style="font-size:20px; color: #20A8D8;" ></i></a>
                            </template>
                            <template slot="completed_status" slot-scope="row" >
                                <button class="btn btn-sm " data-toggle="tooltip" title="Check Completion Status" @click="getCompletionList(row.item)" type="button" style="background: #b0c4de !important;color: #000 !important;">
                                 <i class="cui-check icons font-2xl d-block"></i>
                               </button>
                            </template>
                            
                        </b-table>
                    </b-col>
                    <b-col md="6" >
                        <paginate
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        >
                        </paginate>
            
                    </b-col> 
                </b-row>
            </div>
             <div>
                <b-modal size="xl" title="Status For Dispatch AWB" v-model="dispatchModal" @ok="dispatchModal = false" hide-footer>
                    <b-row md="12">
                    <b-col md="12" class="text-right">
                      <p><b>Total Records :<span style="color:red;">{{ totalRowsDispatch }}</span>
                     </b></p>
                    </b-col>
                    <b-col sm="12">
                        <b-table show-empty responsive   :items="itemsDispatch" :busy="isBusyDispatch" :fields="fieldsDispatch" :filter="filter"  :current-page="currentPageDispatch"  :per-page="perPageDispatch"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered"> 
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div> 

                            <template slot="actions" slot-scope="row" >
                                <a :href="row.item.upload_path" target="_blank"><i
                                    class="fa fa-download"
                                    aria-hidden="true"
                                    title="Click to download"
                                    style="font-size:20px; color: #20A8D8;" ></i></a>
                            </template>
                            <template slot="completed_status" slot-scope="row" >
                                <button class="btn btn-sm " data-toggle="tooltip" title="Check Completion Status" @click="getCompletionList(row.item)" type="button" style="background: #b0c4de !important;color: #000 !important;">
                                 <i class="cui-check icons font-2xl d-block"></i>
                               </button>
                            </template>
                            
                        </b-table>
                    </b-col>
                    <b-col md="6" v-if="totalRowsDispatch>50">
                       
                      <b-pagination
                      v-model="currentPageDispatch"
                      :total-rows="totalRowsDispatch"
                      :per-page="perPageDispatch"
                      class="my-0"
                    ></b-pagination>
            
                
                    </b-col> 
                </b-row>
                </b-modal>
              </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  <script>
    import CONSTANTS from "@/utils/constants";
    import Utils from "@/utils";
    import Vue from "vue";
    import VueBarcode from "vue-barcode";
    export default {
        name: "direct dispatch",
        data: function() {
        return {
            directDispatchCollapse : false,
            selectcsvFile:"",
            selectFiletype:"",
            directDispatcfile:"",
            
            fields: [
                {
                key: "file_id",
                label: "File Id",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "systemusermasterid",
                label: "User Id",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "upload_path",
                label: "File Name",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "uploaded_by",
                label: "Uploaded By",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "uploaded_date",
                label: "Uploaded Date",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "completed_status",
                label: "Check File Completion",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "actions",
                label: "Download CSV",
                sortable: true,
                sortDirection: "desc",
                },
               
            ],
            items:[],
            bordered: true,
            totalRows: 0,

            currentPage: 1,

            perPage: 100,
            pageOptions: [5, 10, 15],
            sortBy: null,
            options: [],
            pageNum: 1,
            noofpages: "",
            sortDesc: false,
            allowCustomValue: true,
            sortDirection: "desc",
            filter: null,
            acceptedAwbNo: [],
            rejectedAwbNoForInvalidStatus: [],
            rejectedAwbNoForInvalidVehicleId: [],
            rejectedDueToInsertError: [],
            deliveredload: [],
            invaliddeliveredload: [],
            rejectedload: [],
            duplicateAwbNoArr:[],
            dispatchModal:false,
            itemsDispatch:[],
            isBusyDispatch:false,
            fieldsDispatch: [
                {
                key: "parentawb",
                label: "Parent AWB",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "vehicle_id",
                label: "Vehicle Id",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "hub_id",
                label: "Hub Id",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "tripid",
                label: "Trip Id",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "ebn",
                label: "EBN ",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "ebnexpirydate",
                label: "EBN Expiry Date",
                sortable: true,
                sortDirection: "desc",
                },
                {
                key: "is_pushed",
                label: "Status",
                sortable: true,
                sortDirection: "desc",
                },
                
               
            ],
            bordered: true,
            totalRowsDispatch: 0,

            currentPageDispatch: 1,

            perPageDispatch: 50,
            pageOptions: [5, 10, 15],
            sortBy: null,
            options: [],
            sortDesc: false,
            allowCustomValue: true,
            sortDirection: "desc",
            filter: null,
            accessBody:[],
             isReadOnly:false,
        }
        },
        created: function() {
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          this.accessBody = userInfo.body;
          this.ischeckbodyvalidation();
            this.uploadDispatchListing(this.pageNum)
        },
        methods: {
          ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.title=='Direct Dispatch' && element.isReadonly==true) {
                  this.isReadOnly=true
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Direct Dispatch' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        clickCallback(pageNum) {
            this.uploadDispatchListing(pageNum);
            },
        uploadDispatchListing(pagee){    
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
       
        const obj={
            systemusermasterid:`${userInfo.sysusermasterid}`,
            page_no: pagee,
        }
        // console.log("objlist",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getDirectDispatchFileUploadListing`,obj).then(result => {
            console.log("result.body",result.body)
            this.isBusy=false;
                  if (result.body.returnmsg === "Successful") {
                   this.items=result.body.returnvalue; 
                   this.totalRows=result.body.totalrecords;
                  //  console.log("TTTTTTT",this.totalRows);
                   this.noofpages = parseInt(this.totalRows) / 100;

                   this.noofpages = Math.ceil(this.noofpages);
                  //  console.log("TTTTTTT",this.noofpages);
                  }else{
                    this.items=[];
                    this.totalRows=0;
                  }
                }).catch(ex => {
                console.log("error", ex);
              });
            },

            showUploadDirectDispatchCSV(){
                this.selectcsvFile='';
                this.selectFiletype='';
                this.directDispatcfile='';
                var showerror = document.getElementById("showerror");
                showerror.style.display = "none";
                this.directDispatchCollapse=!this.directDispatchCollapse
            },

          selectcsvFiletoUpload(event){

            this.selectcsvFile = event.target.files[0];
            console.log("HHH", this.selectcsvFile);

            this.selectFiletype = event.target.files[0].type;
            console.log("selectFiletype", this.selectFiletype);
          },

          uploadDispatchCSVFile(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            document.getElementById("overlay").style.display = "block";
            if (this.selectcsvFile=="") {
                this.$fire({
                text:"Please Upload CSV File",
                type: "error",
                timer: 30000
                }); 
                document.getElementById("overlay").style.display = "none";
                return false;
            }
            if(this.selectFiletype == 'text/csv'){
            let data = new FormData();
            
            data.append('file', this.selectcsvFile)
            data.append('createdby', `${userInfo.sysemailid}`)
            data.append('systemusermasterid', `${userInfo.sysusermasterid}`)
            let config = {
                header : {
                'Content-Type' : 'multipart/form-data'
                }
            }
            console.log("Config",config);
                // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadDirectDispatchCsv`,
                data,{ header : {
                    'Content-Type' : 'multipart/form-data'
                }
                }).then(result => {
                document.getElementById("overlay").style.display = "none";
               
                 if (result.body.returnmsg === 'Successful') {   
                    this.directDispatchCollapse=!this.directDispatchCollapse   

                    this.$fire({
                        text:`File Uploaded ${result.body.returnmsg}`,
                        type: "success",
                        timer: 30000
                    });

                    this.acceptedAwbNo =result.body.returnvalue.acceptedAwbNo;
                    this.rejectedAwbNoForInvalidStatus = result.body.returnvalue.rejectedAwbNoForInvalidStatus;
                    this.rejectedAwbNoForInvalidVehicleId = result.body.returnvalue.rejectedAwbNoForInvalidVehicleId;
                    this.rejectedDueToInsertError = result.body.returnvalue.rejectedDueToInsertError;
                    this.duplicateAwbNoArr = result.body.returnvalue.duplicateAwbNoArr;
                    
                    var showerror = document.getElementById("showerror");
                    showerror.style.display = "block";
                    this.selectcsvFile='';
                    this.selectFiletype='';
                    this.directDispatcfile='';
                    this.uploadDispatchListing(this.pageNum);

                    }else if(result.body.returnmsg === 'Unsuccessful' && typeof(result.body.returnvalue)=='string'){
                        this.selectcsvFile='';
                        this.selectFiletype='';
                        this.directDispatcfile='';
                        this.$fire({
                            text:`Error : ${result.body.returnvalue}`,
                            type: "error",
                            timer: 30000
                        }); 
                    }else{
                
                    this.directDispatchCollapse=!this.directDispatchCollapse  
                    const uploadMessage = result.body.returnvalue.duplicateAwbNoArr && result.body.returnvalue.duplicateAwbNoArr.length
                        ? 'Please try uploading the file once again.'
                        : `File Uploaded ${result.body.returnmsg}`;
                    this.$fire({
                        text:uploadMessage,
                        type: "error",
                        timer: 30000
                    }); 
                    this.acceptedAwbNo =result.body.returnvalue.acceptedAwbNo;
                    this.rejectedAwbNoForInvalidStatus = result.body.returnvalue.rejectedAwbNoForInvalidStatus;
                    this.rejectedAwbNoForInvalidVehicleId = result.body.returnvalue.rejectedAwbNoForInvalidVehicleId;
                    this.rejectedDueToInsertError = result.body.returnvalue.rejectedDueToInsertError;
                    this.duplicateAwbNoArr = result.body.returnvalue.duplicateAwbNoArr;
                    this.selectcsvFile='';
                    this.selectFiletype='';
                    this.directDispatcfile='';
                   
                    var showerror = document.getElementById("showerror");
                    showerror.style.display = "block";
                    this.selectcsvFile='';
                    this.selectFiletype='';
                    this.directDispatcfile='';

                    }

                }).catch(ex => {
                console.log("error", ex);
                });
            }else{
            document.getElementById("overlay").style.display = "none";
                this.$fire({
                text:"Please Upload CSV File Only",
                type: "error",
                timer: 30000
                }); 
            }
          },
          getCompletionList(item){
            console.log("item",item)
            this.dispatchModal=true;
            this.isBusyDispatch=true;
            const obj={
                fileid:`${item.file_id}`,
            }
            // console.log("objlist",obj)
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getStatusForDispatchForceFullyLoads`,obj).then(result => {
               
                this.isBusyDispatch=false;
                    if (result.body.returnmsg === "Successful") {
                    this.itemsDispatch=result.body.returnvalue; 
                    this.totalRowsDispatch=result.body.returnvalue.length;
                   
                    }else{
                        this.itemsDispatch=[];
                        this.totalRowsDispatch=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
            }
        }  
    }
  </script>
  <style></style>
